// extracted by mini-css-extract-plugin
export default {"approve-event-button":"styles_approve-event-button__s+9Xr"};